{
    "name": "avheso-mcm",
    "version": "1.74.6",
    "description": "Avheso - MCM",
    "author": "https://themeforest.net/user/srcn",
    "license": "https://themeforest.net/licenses/standard",
    "private": true,
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test"
    },
    "dependencies": {
        "@angular/animations": "19.0.5",
        "@angular/cdk": "19.0.4",
        "@angular/common": "19.0.5",
        "@angular/compiler": "19.0.5",
        "@angular/core": "19.0.5",
        "@angular/fire": "^19.2.0",
        "@angular/forms": "19.0.5",
        "@angular/material": "19.0.4",
        "@angular/material-luxon-adapter": "19.0.4",
        "@angular/material-moment-adapter": "19.0.4",
        "@angular/platform-browser": "19.0.5",
        "@angular/platform-browser-dynamic": "19.0.5",
        "@angular/router": "19.0.5",
        "@fullcalendar/angular": "^6.1.19",
        "@fullcalendar/core": "^6.1.19",
        "@fullcalendar/daygrid": "^6.1.19",
        "@fullcalendar/interaction": "^6.1.19",
        "@jsverse/transloco": "7.5.1",
        "@schedule-x/angular": "^2.33.0",
        "@schedule-x/calendar": "^2.36.0",
        "@schedule-x/drag-and-drop": "^2.36.0",
        "@schedule-x/events-service": "^2.36.0",
        "@schedule-x/resize": "^2.36.0",
        "@schedule-x/theme-default": "^2.36.0",
        "angular-calendar-scheduler": "^18.0.2",
        "apexcharts": "4.3.0",
        "crypto-js": "4.2.0",
        "date-fns": "^4.1.0",
        "daypilot-pro-angular": "^0.0.0",
        "highlight.js": "11.11.1",
        "keycloak-angular": "^19.0.2",
        "keycloak-js": "^26.2.1",
        "lodash-es": "4.17.21",
        "luxon": "3.5.0",
        "moment": "^2.30.1",
        "ng-apexcharts": "1.15.0",
        "ngx-mat-timepicker": "^19.0.0",
        "ngx-quill": "27.0.0",
        "perfect-scrollbar": "1.5.6",
        "qrcode": "^1.5.4",
        "quill": "2.0.3",
        "rxjs": "7.8.1",
        "temporal-polyfill": "^0.3.0",
        "tslib": "2.8.1",
        "zone.js": "0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.2.3",
        "@angular/cli": "19.0.6",
        "@angular/compiler-cli": "19.0.5",
        "@tailwindcss/typography": "0.5.15",
        "@types/chroma-js": "2.4.5",
        "@types/crypto-js": "4.2.2",
        "@types/highlight.js": "10.1.0",
        "@types/jasmine": "5.1.5",
        "@types/lodash": "4.17.13",
        "@types/lodash-es": "4.17.12",
        "@types/luxon": "3.4.2",
        "autoprefixer": "10.4.20",
        "chroma-js": "2.4.2",
        "jasmine-core": "5.1.2",
        "karma": "6.4.4",
        "karma-chrome-launcher": "3.2.0",
        "karma-coverage": "2.2.1",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "lodash": "4.17.21",
        "postcss": "8.4.49",
        "prettier": "3.4.2",
        "prettier-plugin-organize-imports": "4.1.0",
        "prettier-plugin-tailwindcss": "0.6.9",
        "tailwindcss": "3.4.17",
        "typescript": "5.6.3"
    }
}
